<template>
  <transition name="fade">
    <div
      v-show="$store.state.show === 'page8'"
      :class="['page page8', $store.state.show === 'page8' ? 'active' : '']"
    >
      <div class="content">
        <div class="cont">
          <img src="./images/p8-p1-yanzi.png" alt="" class="p1-yanzi abs" />

          <div :class="['screen screen1', $store.state.screen === 'screen16' ? 'active' : '']">
            <img src="./images/p8-p1-diaoxiang.png" alt="" class="p1-diaoxiang abs opacity" />
            <img src="./images/p8-p1-text.png" alt="" class="p1-text abs opacity" />
          </div>

          <img src="./images/p8-p1-chuan1.png" alt="" class="p1-chuan1 abs opacity" />
          <img src="./images/p8-p1-chuan2.png" alt="" class="p1-chuan2 abs opacity" />

          <div :class="['screen screen2', $store.state.screen === 'screen17' ? 'active' : '']">
            <img src="./images/p8-p2-text.png" alt="" class="p2-text opacity abs" />
          </div>

          <img src="./images/p8-p1-molihua.png" alt="" class="p1-molihua abs" />
        </div>
        <img src="./images/yun-zuo.png" alt="" class="yun-zuo abs" />
        <img src="./images/yun-you.png" alt="" class="yun-you abs" />
        <img :class="['tips-up abs']" src="./images/tips-up.png" alt="" />
      </div>
    </div>
  </transition>
</template>

<script>
import $ from "jquery";
export default {
  name: "page8",
  components: {},
  data() {
    return {};
  },
  methods: {
    // 下一页
    nextPage() {
      this.$store.dispatch("setPageFn", "page8");
    },
  },
  mounted() {
  },
  watch: {
    "$store.state.show"() {
      // 你需要执行的代码
      if (this.$store.state.show === "page8") {
        // this.pageOperate();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/mixin";

.page8 {
  background: url("./images/p8-p1-bg.jpg") top center no-repeat;
  background-size: 100% auto;

  &.active {
    .p1-chuan2  {
      -webkit-animation: identifierxr 0.6s ease-out 0.2s;
      animation: identifierxr 0.6s ease-out 0.2s;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }
    .p1-chuan1  {
      -webkit-animation: identifierxr 0.6s ease-out 0.3s;
      animation: identifierxr 0.6s ease-out 0.3s;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }
  }

  .screen2.active {
    .p2-text {
      -webkit-animation: identifieryu 0.6s ease-out 0.2s;
          animation: identifieryu 0.6s ease-out 0.2s;
          -webkit-animation-fill-mode: forwards;
          animation-fill-mode: forwards;
    }
  }

  .screen1.active {
    .p1-diaoxiang {
      -webkit-animation: identifieryu 0.6s ease-out 0.2s;
      animation: identifieryu 0.6s ease-out 0.2s;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }
    .p1-yanzi {
      -webkit-animation: identifierxr 1s ease-out 0.3s;
      animation: identifierxr 1s ease-out 0.3s;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }
    .p1-text {
      -webkit-animation: identifierx 0.6s ease-out 0.3s;
      animation: identifierx 0.6s ease-out 0.3s;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }
  }
  .screen2 {
    z-index: 15;
  }

  .content {
    .p1-diaoxiang {
      top: 510px;
      left: 170px;
      width:  536px;
    }

    .p1-yanzi {
      top: 350px;
      left: 132px;
      width: 586px;
      z-index: 13;
    }
    .p1-chuan1 {
      top: 827px;
      left: 101px;
      width: 424px;
    }

    .p1-chuan2 {
      top: 763px;
      left: 335px;
      width: 420px;
    }

    .p1-molihua {
      width: 100%;
      bottom: 0;
      left: 0;
      z-index: 10;
    }

    .p1-text {
      top: 50px;
      right: 0;
      width: 722px;
    }

    .screen1 {
      z-index: 15;
    }

    .p2-text {
      top: 438px;
      left: 26px;
      width: 571px;
    }
 
  }
}
</style>
